<template>
  <div class="app-container">
    <el-card>
      <div slot="header">
        <span>Status połączeń FTP</span>
        <el-button style="float: right" type="primary" size="small" icon="el-icon-refresh" @click="loadData">
          Odśwież
        </el-button>
      </div>

      <el-table v-loading="loading" :data="integrations" border style="width: 100%">
        <el-table-column label="Login FTP" min-width="160" prop="ftp_login" />
        <el-table-column label="Serwer" width="140" prop="ftp_server" />
        <el-table-column label="Użytkownik" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.user ? scope.row.user.email : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="Status integracji" width="130" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'active' ? 'success' : 'info'" size="small">
              {{ scope.row.status === 'active' ? 'Aktywna' : 'Nieaktywna' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Połączenie FTP" width="140" align="center">
          <template slot-scope="scope">
            <el-tag :type="ftpStatusType(scope.row.ftp_connection_status)" size="small">
              {{ ftpStatusLabel(scope.row.ftp_connection_status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Ostatnie sprawdzenie" width="170">
          <template slot-scope="scope">
            {{ scope.row.ftp_last_checked_at ? formatDate(scope.row.ftp_last_checked_at) : 'Nigdy' }}
          </template>
        </el-table-column>
        <el-table-column label="Błąd" min-width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.ftp_error_message" style="color: #f56c6c">
              {{ scope.row.ftp_error_message }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="Akcje" width="140" align="center">
          <template slot-scope="scope">
            <el-button
              type="warning"
              size="mini"
              :loading="checkingId === scope.row.id"
              @click="checkNow(scope.row)"
            >
              Sprawdź
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import IntegrationResource from '@/api/integration';

const integrationResource = new IntegrationResource();

export default {
  name: 'FtpStatus',
  data() {
    return {
      loading: false,
      integrations: [],
      checkingId: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const response = await integrationResource.getFtpStatus();
        this.integrations = response;
      } catch (e) {
        this.$message.error('Nie udało się pobrać statusu FTP');
      } finally {
        this.loading = false;
      }
    },
    async checkNow(integration) {
      this.checkingId = integration.id;
      try {
        const response = await integrationResource.checkFtpNow(integration.id);
        this.$message({
          type: response.result.success ? 'success' : 'error',
          message: response.message,
        });
        await this.loadData();
      } catch (e) {
        this.$message.error('Nie udało się sprawdzić połączenia FTP');
      } finally {
        this.checkingId = null;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      return d.toLocaleString('pl-PL');
    },
    ftpStatusType(status) {
      const map = { ok: 'success', failed: 'danger', unknown: 'info' };
      return map[status] || 'info';
    },
    ftpStatusLabel(status) {
      const map = { ok: 'OK', failed: 'Błąd', unknown: 'Nieznany' };
      return map[status] || status;
    },
  },
};
</script>
